import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  TypingIndicator,
  Avatar,
} from "@chatscope/chat-ui-kit-react";

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import logo from "../images/cauris.png";
import { Footer } from "../pages/Footer";

import MarkdownComponent from "./MarkdownComponent";
import CustomComponent from "./CustomComponent";
import ReactGA from "react-ga4";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Badge from "react-bootstrap/Badge";

import styles from "./Chat.css";

export const Chat = (props) => {
  var selectedReport = JSON.parse(localStorage.getItem("selectedReport_v2"));
  const [chatContext, setChatContext] = useState(props.selectedReport.history);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  const [streamMessage, setStreamMessage] = useState("");
  const [isStreaming, setIsStreaming] = useState("");

  const [showMonitorModal, setShowMonitorModal] = useState(false);
  const [monitorContent, setMonitorContent] = useState("");
  const [isMonitorReady, setMonitorReady] = useState(false);
  const [newConversationId, setNewConversationId] = useState();
  const [typingIndicatorMessage, setTypingIndicatorMessage] = useState(
    "Credit Copilot is typing"
  );

  const [showDataModal, setShowDataModal] = useState(false);
  const [dataModalContent, setDataModalContent] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [showSQLData, setShowSQLData] = useState(false);
  const [sqlDataContent, setSQLDataContent] = useState("");

  const [newConversationName, setNewConversationName] = useState("");

  const handleCloseDataModel = () => setShowDataModal(false);
  const handleCloseSQLData = () => setShowSQLData(false);

  const handleClose = () => setShowMonitorModal(false);
  const handleShow = () => setShowMonitorModal(true);

  const [isTyping, setIsTyping] = useState(false);
  const [selectedReportName, setSelectedReportName] = useState(
    props.selectedReport.conversation_name
  );

  const [messages, setMessages] = useState(props.selectedReport.history);

  useEffect(() => {
    if (isStreaming == false) {
      setTypingIndicatorMessage("Credit Copilot Is Building A Chart");
    } else {
      setTypingIndicatorMessage("Credit Copilot Is Typing");
    }
  }, [isStreaming]);

  useEffect(() => {
    if (streamMessage.includes("$*END*$")) {
      let json_response = JSON.parse(streamMessage.split("$*END*$")[1]);

      const chatGPTResponse_finish = {
        message: json_response.ai_result.response,
        sender: "Credit Copilot",
        direction: "incoming",
        type: "html",
        payload: json_response.ai_result,
        chart: json_response.ai_result.chart.chart,
        queryResults: json_response.ai_result.queryResults,
        sqlQuery: json_response.ai_result.sqlQuery,
        conversation_id: json_response.conversation_id,
        message_id: json_response.message_id,
      };

      setMessages((prevMessages) => prevMessages.slice(0, -1));
      setMessages((prevMessages) => [...prevMessages, chatGPTResponse_finish]);
      setNewConversationId(json_response.conversation_id);
      props.setUpdateConversations({
        at: Date.now(),
        conversationId: json_response.conversation_id,
      });
      setChatContext((prevMessages) => [
        ...prevMessages,
        chatGPTResponse_finish,
      ]);

      setIsTyping(false);
    }
  }, [streamMessage]);

  const tableRef = useRef(null);
  const getTableString = (table) => {
    let tableString = "";
    const rows = Array.from(table.querySelectorAll("tr"));

    rows.forEach((row) => {
      const cells = Array.from(row.querySelectorAll("td, th"));
      const rowString = cells.map((cell) => cell.textContent).join("\t");
      tableString += rowString + "\n";
    });

    return tableString;
  };
  const copyTable = () => {
    if (tableRef.current) {
      const tableString = getTableString(tableRef.current);
      try {
        navigator.clipboard.writeText(tableString);
      } catch (error) {
        console.error("Failed to copy:", error);
      }
    }
  };

  useEffect(() => {
    if (isTyping) {
      return;
    }
    const e = JSON.parse(localStorage.getItem("selectedReport_v2"));
    console.log("e", e);

    if (e.is_retry) {
      setMessages(e.history);
      e.is_retry = false;
      console.log("chatContext", JSON.stringify(e));
      localStorage.setItem("selectedReport_v2", JSON.stringify(e));
    }

    if (messages.length > 0 && messages[0].message !== e.history[0].message) {
      setMessages(e.history);
    }

    console.log("C ID", messages, e);
    if (
      messages.length > 0 &&
      messages[0].conversation_id !== e.history[0].conversation_id
    ) {
      console.log("HI CHAT", messages);
      setMessages(e.history);
    }

    // if (
    //   messages.length > 0 &&
    //   messages[0].message !== e.history[0].message &&
    //   messages.length !== e.history.length
    // ) {
    //   setMessages(e.history);
    // }
  }, [messages, props]);

  useEffect(() => {
    setChatContext(selectedReport.history);
  }, [props.selectedReport]);

  useEffect(() => {
    props.onSelectReport(selectedReport.history);
    var conversations = JSON.parse(localStorage.getItem("conversations_v2"));
    if (conversations === undefined || conversations === null) {
      conversations = [];
    }

    if (messages.length > 1) {
      var conversation = {};

      var conversation_name = newConversationName;

      if (selectedReport.conversation_name != undefined) {
        conversation_name = selectedReport.conversation_name;
      }

      // if (messages[0].direction === "outgoing") {
      //   conversation_name = clean_prompt(messages[0].message);
      // }
      // console.log(
      //   "selectedReport.conversationName",
      //   selectedReport.conversationName
      // );
      // if (selectedReport.conversationName != undefined) {
      //   conversation_name = selectedReport.conversationName;
      // }

      conversation["conversation_name"] = conversation_name;
      conversation["history"] = messages;
      conversation["country"] = selectedReport.country;
      conversation["company"] = selectedReport.portco;
      conversation["portco"] = selectedReport.portco;
      conversation["time"] = new Date();
      conversation["partner_id"] = selectedReport.partner_id;

      let last_message = messages[messages.length - 1];

      if (last_message["last_update"] != undefined) {
        conversation["last_update"] = last_message["last_update"];
      }

      var exists = false;
      for (var c in conversations) {
        const convo = conversations[c];

        if (convo.conversation_name == conversation_name) {
          conversations[c] = conversation;
          exists = true;
        }
      }
      if (!exists) {
        conversations.push(conversation);
      }

      // try {
      //   localStorage.setItem("conversations_v2", JSON.stringify(conversations));
      //   localStorage.setItem("selectedReport_v2", JSON.stringify(conversation));
      // } catch (e) {
      //   console.log("Error");
      // }

      props.setUpdateChatLogProp();
    } else if (messages.length == 1 && messages[0].direction == "outgoing") {
      console.log("SEND IT");
      handleSendRequest(messages[0].message, true);
    }
  }, [messages]);

  function sendMessage(text) {
    window.alert(text);
  }

  function editContext(c) {
    let newContext = [];

    for (var conv in c) {
      let existing = c[conv];
      let new_conv = {};
      // new_conv["message"] = existing["message"];

      if (existing["direction"] == "outgoing") {
        new_conv["user"] = existing["message"];
      } else {
        new_conv["system"] = existing["message"];
        // new_conv["queryResults"] = existing["queryResults"];
      }
      newContext.push(new_conv);
      console.log("EDIT CONV", conv);
    }
    return newContext;
  }

  function clean_prompt(msg) {
    var div = document.createElement("div");
    div.innerHTML = msg;
    return div.textContent || div.innerText || "";
  }

  const handleSendRequest = async (raw_message, isInitial) => {
    setStreamMessage("");
    const profile = JSON.parse(localStorage.getItem("g_profile"));

    var message = clean_prompt(raw_message);

    // var message = cleanPrompt(raw_message);
    const newMessage = {
      message,
      direction: "outgoing",
      sender: "user",
      message: message,
    };
    //    setItems(prevItems => [...prevItems, `item${prevItems.length + 1}`]);

    setChatContext((prevMessages) => [...prevMessages, newMessage]);
    setTypingIndicatorMessage("Credit Copilot Is Researching");
    setIsTyping(true);

    ReactGA.event({
      category: "Prompt",
      action: message,
    });

    const conversation_item = {};
    conversation_item["role"] = "user";
    conversation_item["content"] = message;

    // setMessages((prevMessages) => [...prevMessages, newMessage]);

    // setChatContext((prevMessages) => [...prevMessages, message]);
    var appended_history = messages;
    console.log("isInitial", isInitial);
    if (isInitial == true) {
      appended_history = [];
      appended_history.push(newMessage);
      console.log("INITIAL");
    } else {
      appended_history.push(newMessage);
      console.log("EXISTING");
    }
    var conversation_id_temp = selectedReport.conversation_id;
    if (conversation_id_temp == undefined) {
      conversation_id_temp = newConversationId;
    }

    let body = JSON.stringify({
      context: editContext(chatContext),
      query: message,
      database: selectedReport.portco.toUpperCase() + "_AGENT_V2",
      country: selectedReport.country,
      send_slack: props.sendSlack,
      partner_id: selectedReport.partner_id,
      sender_id: profile.email,
      conversation_id: conversation_id_temp,
      conversationName: newConversationName,
    });
    try {
      const response = await fetch(
        process.env.REACT_APP_API_DOMAIN + "/queryStream",
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,

            "Content-Type": "application/json",
          },
          body: body, // Replace with your data
        }
      );

      const reader = response.body.getReader();
      const chatGPTResponse = {
        message: streamMessage,
        sender: "Credit Copilot",
        direction: "incoming",
        type: "html",
        reader: reader,
      };
      setMessages((prevMessages) => [...prevMessages, chatGPTResponse]);
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  };

  function isObject(val) {
    if (val === null) {
      return false;
    }
    return typeof val === "function" || typeof val === "object";
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        paddingRight: "0px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <MainContainer>
        <Modal show={showDataModal} onHide={handleCloseDataModel} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>CSV Data</Modal.Title>
            <Button onClick={copyTable} variant="link">
              {" "}
              <Badge bg="secondary">📋 Copy</Badge>
            </Button>
          </Modal.Header>
          <Modal.Body>
            <div>
              <table id="table" ref={tableRef} className="dataTable">
                <thead>
                  <tr>
                    {dataModalContent[0] &&
                      Object.keys(dataModalContent[0]).map((header) => (
                        <th key={header}>{header}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {dataModalContent.map((row, index) => (
                    <tr key={index}>
                      {Object.values(row).map((cell, index) => (
                        <td key={index}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {isDataReady ? (
              <div></div>
            ) : (
              <div className="monitorLoader">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDataModel}>
              Close
            </Button>{" "}
          </Modal.Footer>
        </Modal>

        <Modal show={showSQLData} onHide={handleCloseSQLData} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>SQL Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <pre>{sqlDataContent}</pre>
          </Modal.Body>
          <Modal.Footer>
            {isMonitorReady ? (
              <div>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>{" "}
              </div>
            ) : (
              <div></div>
            )}
          </Modal.Footer>
        </Modal>

        <Modal show={showMonitorModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Monitoring</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="markdownDiv"
              dangerouslySetInnerHTML={{
                __html: monitorContent,
              }}
            ></div>
            {isMonitorReady ? (
              <div></div>
            ) : (
              <div className="monitorLoader">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {isMonitorReady ? (
              <div>
                <Button variant="secondary" onClick={handleClose}>
                  Close
                </Button>{" "}
                <Button variant="success" onClick={handleClose}>
                  Start Monitoring
                </Button>
              </div>
            ) : (
              <div></div>
            )}
          </Modal.Footer>
        </Modal>

        <ChatContainer>
          <MessageList
            typingIndicator={
              isTyping ? (
                <TypingIndicator content={typingIndicatorMessage} />
              ) : null
            }
          >
            {messages.map((message, i) => {
              return (
                <Message
                  key={i}
                  model={{
                    type: "html",
                    direction: message.direction,
                  }}
                  avatarPosition="tl"
                >
                  {" "}
                  {message.direction === "incoming" ? (
                    <div></div>
                  ) : (
                    <Avatar name="" src={profile.picture} />
                  )}
                  {isObject(message.message) ? (
                    <Message.CustomContent>
                      <CustomComponent
                        content={message.message}
                        chart={message.chart}
                      />
                    </Message.CustomContent>
                  ) : (
                    <Message.CustomContent>
                      <MarkdownComponent
                        content={message.message}
                        direction={message.direction}
                        chart={message.chart}
                        data={message.queryResults}
                        table={message.table}
                        sqlQuery={message.sqlQuery}
                        message_id={message.message_id}
                        feedback={message.feedback}
                        reader={message.reader}
                        setShowMonitorModal={setShowMonitorModal}
                        setMonitorContent={setMonitorContent}
                        setMonitorReady={setMonitorReady}
                        setShowDataModal={setShowDataModal}
                        setDataModalContent={setDataModalContent}
                        setIsDataReady={setIsDataReady}
                        setShowSQLData={setShowSQLData}
                        setSQLDataContent={setSQLDataContent}
                        partner_id={selectedReport.partner_id}
                        partnerMetadata={props.partnerMetadata}
                        profile={profile}
                        onSelectReport={props.onSelectReport}
                        setIsStreaming={setIsStreaming}
                        setStreamMessage={setStreamMessage}
                      />
                    </Message.CustomContent>

                    // <Message.HtmlContent html={message.message} />
                  )}
                </Message>
              );
            })}
          </MessageList>

          {selectedReport !== undefined ? (
            <MessageInput
              onSend={handleSendRequest}
              attachButton={false}
              placeholder={
                "Ask me about the " +
                // selectedReport.portco.toUpperCase() +
                " portfolio. If you want to filter by country, just ask!"
              }
              height="200px"
            />
          ) : (
            <MessageInput
              attachButton={false}
              placeholder="Select a report to start"
              height="200px"
            />
          )}
        </ChatContainer>
      </MainContainer>
    </div>
  );
};
export default Chat;
